<div class="grid-wrapper flex-col" [class.grid-wrapper-disabled]="disabled" [class.content-fit-widths-pending]="expandsContentColumnsToTableWidth() && !contentFitFillColumnWidthsApplied">
  <ag-grid-angular #grid
    [class]="'flex-item-fill ag-theme-' + getTheme()"
    [class.sm-table-tree]="isTree"
    [rowData]="_data?.rows"
    [suppressScrollOnNewData]="suppressScrollOnNewData"
    [treeData]="isTree"
    [getDataPath]="getDataPath"
    [groupDisplayType]="treeGroupColumnId == null ? 'singleColumn' : 'custom'"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [groupDefaultExpanded]="groupDefaultExpanded"
    [pinnedBottomRowData]="internalPinnedBottomRows"
    [columnDefs]="colDefs"
    [animateRows]=false
    [getRowId]="_data?.useRowIds ? getRowId : undefined"
    [context]="context"
    [gridOptions]="gridOptions"
    [localeText]="_SmTableComponent.locale"
    [rowSelection]="
            rowSelectionAllowed ? { mode: multiSelection ? 'multiRow' : 'singleRow', checkboxes: _checkBoxSelection, enableClickSelection: !_checkBoxSelection,
                isRowSelectable: canSelectRow == null ? undefined : isRowSelectable, hideDisabledCheckboxes: canSelectRow != null,
                groupSelects: groupSelectsDescendants ? 'descendants' : 'self' } : undefined
        "
    [selectionColumnDef]="{ width: 40, maxWidth: 40, pinned: 'left' }"
    [getRowClass]="getRowClass"
    [components]="components"
    [enableCellTextSelection]="allowCellTextSelection"
    [domLayout]="autoHeight ? 'autoHeight' : undefined"
    [tooltipShowDelay]="500"
    [tooltipShowMode]="'whenTruncated'"
    [suppressCellFocus]=true
    [stopEditingWhenCellsLoseFocus]="stopEditingWhenCellsLoseFocus"
    [rowDragManaged]="_allowRowDrag && rowDragManaged"
    [rowDragText]="getRowDragText"
    [getRowHeight]="getRowHeight"
    [tabToNextCell]="tabForSameCol ? tabToNextCellBound : undefined"
    overlayLoadingTemplate="<span></span>"
    (cellKeyDown)="cellKeyDown($event)"
    (cellClicked)="cellClicked($event)"
    (rowDoubleClicked)="rowDoubleClicked($event)"
    (cellEditingStarted)="cellEditingStarted($event)"
    (cellEditingStopped)="cellEditingStopped($event)"
    (cellContextMenu)="cellContextMenu($event)"
    (contextmenu)="gridContextMenu($event)"
    (cellFocused)="cellFocused($event)"
    (rowSelected)="rowSelected($event)"
    (rowDragEnd)="rowDragEnd($event)"
    (rowDragMove)="rowDragMove($event)"
    (selectionChanged)="selectionChanged($event)"
    (cellValueChanged)="cellValueChanged($event)"
    (sortChanged)="sortChanged($event)"
    (columnMoved)="columnStatusChanged($event)"
    (columnResized)="columnStatusChanged($event)"
    (columnVisible)="columnStatusChanged($event)"
    (rowGroupOpened)="rowGroupOpened($event)"
    (gridReady)="gridReady($event)"
    (filterChanged)="filterChanged($event)"
    (modelUpdated)="modelUpdated($event)"
    [rowNumbers]="isEnterprise && displayRowNumbers"
    [sideBar]="isEnterprise && displaySideBar"
    >
  </ag-grid-angular>  
  @if (summaryRow != null) {
    @if (summaryRow == "numRows") {
        <div class="mt-2">
            Anzahl  Zeilen: {{_data?.rows?.length}}
        </div>
    }
    @else if (summaryRow == "numSel") {
        <div class="mt-2">
            Selektiert: {{getSelectedRowCount()}}
        </div>
    }
    @else if (summaryRow == "numRowsNumSel") {
        <div class="mt-2">
            Anzahl  Zeilen: {{_data?.rows?.length}}, Selektiert: {{getSelectedRowCount()}}
        </div>
    }    
  }
  @if (disabled) {
    <div class="grid-overlay"></div>
  }
</div>
<p-contextMenu #settingsMenu [model]="settingsItems" [style.width]="'500px'" [appendTo]="'body'">
  <ng-template #item let-item>
    @if (item.data?.tableQuickFilter) {
      <div class="table-quick-filter" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <i class="fas fa-search"></i>
        <input
          #quickFilterInput
          pInputText
          type="text"
          placeholder="Tabelle durchsuchen"
          [ngModel]="quickFilterText"
          (ngModelChange)="setQuickFilterText($event)"
          (keydown.enter)="settingsMenu.hide()"
        />
        @if (quickFilterText != "") {
          <p-button icon="fas fa-times" [text]=true title="Tabellensuche zurücksetzen" (onClick)="setQuickFilterText('')"></p-button>
        }
      </div>
    }
    @else {
      <a class="p-contextmenu-item-link" [title]="item.title">
        @if (item.icon) {
          <span class="p-contextmenu-item-icon" [ngClass]="item.icon"></span>
        }
        <span class="p-contextmenu-item-label">{{ item.label }}</span>
        @if (item.badge) {
          <p-badge [value]="item.badge" [styleClass]="item.badgeStyleClass"></p-badge>
        }
        @if (item.items?.length > 0) {
          <span class="p-contextmenu-submenu-icon fas fa-angle-right"></span>
        }
      </a>
    }
  </ng-template>
</p-contextMenu>
